import React, { useEffect } from "react";
import { Form, Input, DatePicker, Select, InputNumber } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingClassDetails, 
	doTrainingClassCreate, 
	doTrainingClassUpdate 
} from "../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { 
	DATE_FORMAT_MDY, 
	DATE_FORMAT,
	TIME_FORMAT,
	MODULE_TRAINING_CLASS
} from "variables/constants";
import TextArea from "antd/es/input/TextArea"


const TrainingClassForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;
	const { RangePicker } = DatePicker;
	
	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

  	const onSubmit = (formData) => {	
    	try {  
			if (formData.tcl_date_range?.length === 2) {
				formData.tcl_schedule_date_from = formData.tcl_date_range[0].format(`${DATE_FORMAT} ${TIME_FORMAT}`);
				formData.tcl_schedule_date_to = formData.tcl_date_range[1].format(`${DATE_FORMAT} ${TIME_FORMAT}`);
				}
				delete formData.tcl_date_range;
				
			recordData.tcl_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className={mode !== "view" ? "form" : ""}
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="tcl_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			
			<div className="grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-4 w-full">         		            	            
				<div className="col-span-3">
					<div className="grid grid-cols-1 md:grid-cols-5 gap-2 w-full">
						<FormItem className="font-medium mb-2 col-span-1 md:col-span-4"
							name="tcl_title"
							label="Course Name"
							rules={[requiredField]}
							
						>
							<Input
								id="tcl_title"
								className="input-field"
								maxLength={100}
								placeholder="Enter course name"
							/>
						</FormItem>
						<FormItem className="font-medium mb-2 col-span-1"
							name="tcl_code"
							label="Course Code"
							rules={[requiredField]}
							
						>
							<Input
								id="tcl_code"
								className="input-field"
								maxLength={20}
								placeholder="Enter course code"
							/>
						</FormItem>
					</div>
				</div>
				<div className="col-span-3">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-2 w-full">
						<FormItem 
						className="font-medium mb-2"
						name="tcl_instructor_user_id"
						label="Instructor"
						rules={[requiredField]}
							
						>
							<Select 
								id="tcl_instructor_user_id"
								className="input-field"
								allowClear={true}
								options={recordData?.userList}
								placeholder="Select instructor"
							/>
						</FormItem>
						<FormItem
							className="font-medium mb-2"
							name="tcl_course_category"
							label="Category"
							rules={[requiredField]}

						>
							<Select 
								id="tcl_course_category"
								className="input-field"
								allowClear={true}
								options={recordData?.categoryList}
								placeholder="Select category"
							/>
						</FormItem>
						<FormItem
							className="font-medium mb-2"
							name="tcl_difficulty_id"
							label="Difficulty Level"
							rules={[requiredField]}

						>
							<Select 
								id="tcl_difficulty_id"
								className="input-field"
								allowClear={true}
								options={recordData?.difficultyList}
								placeholder="Select level"
							/>
						</FormItem>
					</div>
				</div>
				<FormItem 
					className="font-medium mb-2 col-span-3"
					name="tcl_description"
					label="Description"
					rules={[requiredField]}
					
				>
					<TextArea
						id="tcl_description"
						className="input-field"
						maxLength={255}
						placeholder="Describe the course content and objectives"
					/>
				</FormItem>
				<div className="col-span-3 mb-2">
					<div className="grid grid-cols-1 md:grid-cols-4 gap-2 w-full">
						<div className="md:col-span-2">
							<FormItem
								className="font-medium mb-2 col-span-1 md:col-span-2"
								name="tcl_date_range" 
								label="Date"
								rules={[requiredField]}
							>
								<RangePicker
									id="tcl_date_range"
									className="input-field w-full"
									format={`${DATE_FORMAT_MDY}`}
									valueFormat="YYYY-MM-DD HH:mm:ss" 
								/>
							</FormItem>
						</div>
				
						<div className="grid grid-cols-[3fr_1fr] gap-2 md:col-span-2">
							<FormItem
								label="Client"
								name="tcl_client_id"
								rules={[requiredField]}

							>
								<Select 
									id="tcl_client_id"
									className="input-field"
									allowClear={true}
									options={recordData?.clientList}
									placeholder="Select client"
								/>
							</FormItem>
							<FormItem
								label="Max"
								name="tcl_max_participant"

							>
								<InputNumber 
									id="tcl_max_participant"
									className="input-field"
									min={1} 
									max={50}
									placeholder="e.g., 30"
								/>
							</FormItem>
						</div>
					</div>
				</div>
			</div>

			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.tcl_id ?? 0}
						isModal={true}
						modalId={recordData?.tcl_id > 0 ? 'edit_classModule' : 'add_trainingClass'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel="Save Course"
						moduleId={MODULE_TRAINING_CLASS}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingClass.trainingClassDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getTrainingClassDetails(id)),
  	doCreate: (data) => dispatch(doTrainingClassCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingClassUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassForm);
